/* Armoni — ficha de cabecero: desplegables (medida, instalación, color), medida a medida, precio con medida, patas y regalo. */
(() => {
  if (window.__armoniPdp) return;
  window.__armoniPdp = true;

  const money = (cents) => (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  const COLORS = {antracita:'#3d3e40',steel:'#8a9099',perla:'#cbc7c0',neutro:'#ddd7cd',sand:'#bdb5a8',land:'#6c5f53',oro:'#c8a15a',turquesa:'#2f6e72',coral:'#8e3340',rosa:'#c39aa4',blanco:'#f1efea'};
  const colorHex = (n) => { n = (n || '').toLowerCase(); for (const k in COLORS) if (n.includes(k)) return COLORS[k]; return '#cfc9bf'; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const CHEVRON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  // Tipo de instalación: se apoya en la opción "Altura" del producto (+ patas como producto aparte)
  const INST = [
    { key: 'suelo', radio: '120 cm', label: 'Apoyado en suelo', sub: '120 cm de alto' },
    { key: 'pared', radio: '60 cm', label: 'Colgado en pared', sub: '60 cm de alto' },
    { key: 'patas', radio: '120 cm', label: 'Apoyado en suelo con patas', sub: '+15 €' }
  ];
  const NAMES = { Medida: 'medida', Altura: 'tipo de instalación', Color: 'color' };

  const state = { custom: false, patas: false, inst: null, ui: null, sim: null, promo: null, open: null, err: null, chosen: { Medida: false, Altura: false, Color: false } };

  const root = () => document.querySelector('[data-armoni-pdp]');
  function variants() {
    const el = document.querySelector('[data-armoni-variants]');
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function picker() {
    const r = root();
    return r ? document.querySelector(`variant-picker[data-section-id="${r.dataset.sectionId}"]`) : null;
  }
  function fieldset(name) {
    const pk = picker();
    if (!pk) return null;
    for (const fs of pk.querySelectorAll('fieldset.variant-option')) {
      const lg = fs.querySelector('legend');
      if (lg && lg.textContent.trim().startsWith(name)) return fs;
    }
    return null;
  }
  function selected(name) {
    const fs = fieldset(name);
    const input = fs && fs.querySelector('input[type=radio]:checked');
    return input ? input.value : null;
  }
  function tiers(color) {
    return variants()
      .filter((v) => v.o1 && v.o1.startsWith('A medida') && (!color || v.o3 === color))
      .map((v) => ({ ...v, max: parseInt(v.o1.replace(/\D+/g, ' ').trim().split(' ').pop(), 10) }))
      .sort((a, b) => a.max - b.max);
  }
  function customValues() {
    const ui = state.ui;
    return {
      w: parseInt(ui.querySelector('[data-armoni-ancho]').value, 10) || null,
      h: parseInt(ui.querySelector('[data-armoni-alto]').value, 10) || null
    };
  }
  function customVariant() {
    const ui = state.ui;
    const { w, h } = customValues();
    const list = tiers(selected('Color'));
    const msg = ui.querySelector('[data-armoni-msg]');
    const price = ui.querySelector('[data-armoni-price]');
    msg.textContent = ''; price.textContent = '';
    if (!list.length || !w) return null;
    const maxW = list[list.length - 1].max;
    if (w < 60 || w > maxW) { msg.textContent = `El ancho debe estar entre 60 y ${maxW} cm.`; return null; }
    if (h && (h < 40 || h > 140)) { msg.textContent = 'El alto debe estar entre 40 y 140 cm.'; return null; }
    const v = list.find((t) => w <= t.max);
    price.innerHTML = `Precio a medida: <strong>${money(v.price)}</strong>`;
    return { v, w, h };
  }
  function altoTotal() {
    return parseInt(selected('Altura') || '120', 10) + (state.patas ? 15 : 0);
  }
  function instOptions(fs) {
    const vals = [...fs.querySelectorAll('input[type=radio]')].map((i) => i.value);
    const hasPatas = !!(root() && root().dataset.patasId);
    return INST.filter((o) => vals.includes(o.radio) && (o.key !== 'patas' || hasPatas));
  }
  function instText(o) { return `${esc(o.label)} <small class="armoni-dd__sub">— ${esc(o.sub)}</small>`; }

  function optionText(name, value) {
    if (name === 'Medida') return esc(value.replace(/x\s*\d+\s*cm/, `x ${altoTotal()} cm`));
    if (name === 'Color') return `<span class="armoni-color-dot" style="--swatch:${colorHex(value)}"></span>${esc(value)}`;
    return esc(value);
  }
  function buttonText(name) {
    if (name === 'Medida' && state.custom) {
      const { w, h } = customValues();
      return w && h ? `Medida a medida: <b>${w} x ${h} cm</b>` : 'Medida a medida: <b>escribe ancho y alto</b>';
    }
    if (name === 'Altura') {
      const o = INST.find((x) => x.key === state.inst);
      return state.chosen.Altura && o ? `Instalación: <b>${instText(o)}</b>` : 'Seleccionar tipo de instalación';
    }
    const cur = selected(name);
    if (!state.chosen[name] || !cur) return `Seleccionar ${NAMES[name]}`;
    const label = name === 'Color' ? 'Color seleccionado' : 'Medida seleccionada';
    return `${label}: <b>${optionText(name, cur)}</b>`;
  }

  function buildDropdown(fs, name) {
    const isInst = name === 'Altura';
    const opts = isInst
      ? instOptions(fs).map((o) => ({ val: o.key, html: instText(o), sel: state.chosen.Altura && state.inst === o.key, dis: false }))
      : [...fs.querySelectorAll('input[type=radio]')].filter((i) => !i.value.startsWith('A medida')).map((i) => ({
          val: i.value, html: optionText(name, i.value), dis: i.disabled,
          sel: state.chosen[name] && !(name === 'Medida' && state.custom) && i.value === selected(name)
        }));
    const btn = buttonText(name);
    const open = state.open === name;
    const err = state.err === name;
    const sig = JSON.stringify([opts, btn, open, err]);
    let dd = fs.querySelector(':scope > .armoni-dd');
    if (dd && dd.dataset.sig === sig) return dd;
    if (!dd) {
      dd = document.createElement('div');
      dd.className = 'armoni-dd';
      dd.dataset.dd = name;
      const legend = fs.querySelector('legend');
      legend ? legend.after(dd) : fs.prepend(dd);
    }
    dd.dataset.sig = sig;
    const chosenNow = (state.chosen[name] && !(name === 'Medida' && state.custom)) || (name === 'Medida' && state.custom);
    dd.classList.toggle('is-open', open);
    dd.classList.toggle('is-chosen', chosenNow);
    dd.classList.toggle('has-error', err);
    dd.innerHTML =
      `<button type="button" class="armoni-dd__btn" aria-expanded="${open}" data-dd-toggle="${name}"><span>${btn}</span>${CHEVRON}</button>` +
      `<ul class="armoni-dd__list" role="listbox" aria-label="${esc(NAMES[name])}"${open ? '' : ' hidden'}>` +
      opts.map((o) => `<li><button type="button" role="option" aria-selected="${o.sel}" data-dd-name="${name}" data-dd-val="${esc(o.val)}"${o.dis ? ' disabled' : ''}>${o.html}</button></li>`).join('') +
      '</ul>' +
      (err ? `<p class="armoni-dd__err" role="alert">Elige ${{ Medida: 'una medida', Altura: 'el tipo de instalación', Color: 'un color' }[name]} para continuar.</p>` : '');
    return dd;
  }

  function decorate() {
    const r = root();
    if (!r) return;
    if (!state.ui) state.ui = r.querySelector('[data-armoni-ui]');
    if (!state.sim) state.sim = r.querySelector('[data-armoni-sim]');
    if (!state.promo) state.promo = r.querySelector('[data-armoni-promo]');
    document.querySelectorAll('[data-armoni-ui],[data-armoni-sim],[data-armoni-promo]').forEach((n) => {
      if (n !== state.ui && n !== state.sim && n !== state.promo) n.remove();
    });

    const fsM = fieldset('Medida');
    const fsA = fieldset('Altura');
    const fsC = fieldset('Color');
    [['Medida', fsM], ['Altura', fsA], ['Color', fsC]].forEach(([name, fs]) => {
      if (!fs) return;
      fs.dataset.armoni = name.toLowerCase();
      fs.classList.add('armoni-dd-host');
      const dd = buildDropdown(fs, name);
      if (name === 'Medida' && state.ui && dd.nextElementSibling !== state.ui) dd.after(state.ui);
    });
    if (state.sim && fsC && fsC.nextElementSibling !== state.sim) fsC.after(state.sim);

    document.documentElement.classList.toggle('armoni-custom-mode', state.custom);
    if (state.ui) {
      state.ui.querySelector('[data-armoni-chip]').setAttribute('aria-expanded', String(state.custom));
      state.ui.querySelector('[data-armoni-panel]').classList.toggle('is-open', state.custom);
    }

    const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };

    // Precio (+ patas), tachado, % y medida elegida junto al título
    const row = document.querySelector('[data-armoni-price-row]');
    if (row) {
      let v = null, size = '';
      const extra = state.patas ? Number(r.dataset.patasPrice || 0) : 0;
      if (state.custom) {
        const { w, h } = customValues();
        const list = tiers(selected('Color'));
        v = w ? list.find((t) => w <= t.max) || null : null;
        size = w && h ? `A medida (${w} x ${h} cm)` : 'A medida';
      } else {
        const m1 = selected('Medida'), m2 = selected('Altura'), m3 = selected('Color');
        v = variants().find((x) => x.o1 === m1 && x.o2 === m2 && (!m3 || x.o3 === m3)) || null;
        if (m1) size = m1.replace(/x\s*\d+\s*cm/, `x ${altoTotal()} cm`) + (state.patas ? ' con patas' : '');
      }
      const now = row.querySelector('[data-ap-now]'), was = row.querySelector('[data-ap-was]'), off = row.querySelector('[data-ap-off]');
      if (v) {
        setText(now, money(v.price + extra));
        const disc = v.cmp > v.price;
        if (was.hidden === disc) was.hidden = !disc;
        if (off.hidden === disc) off.hidden = !disc;
        if (disc) { setText(was, money(v.cmp + extra)); setText(off, `-${Math.floor((v.cmp - v.price) * 100 / v.cmp)}%`); }
      }
      setText(row.querySelector('[data-ap-size]'), size);
    }

    if (state.sim) {
      const u = new URL(state.sim.href, location.origin);
      const c = selected('Color');
      if (c && state.chosen.Color) u.searchParams.set('color', c);
      const nh = u.pathname + u.search;
      if (state.sim.getAttribute('href') !== nh) state.sim.setAttribute('href', nh);
    }
  }

  let scheduled = false;
  const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; decorate(); }); };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

  function clickRadio(name, val) {
    const fs = fieldset(name);
    const input = fs && [...fs.querySelectorAll('input[type=radio]')].find((i) => i.value === val);
    if (input && !input.checked) input.click();
  }

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-armoni-chip]');
    if (chip) {
      state.custom = !state.custom; state.open = null; state.err = null;
      if (state.custom) { state.patas = false; if (state.inst === 'patas') { state.inst = null; state.chosen.Altura = false; } }
      decorate();
      if (state.custom) state.ui.querySelector('[data-armoni-ancho]').focus();
      return;
    }
    const tg = e.target.closest('[data-dd-toggle]');
    if (tg) { state.open = state.open === tg.dataset.ddToggle ? null : tg.dataset.ddToggle; decorate(); return; }
    const opt = e.target.closest('[data-dd-val]');
    if (opt) {
      const name = opt.dataset.ddName;
      const val = opt.dataset.ddVal;
      state.chosen[name] = true; state.open = null;
      if (state.err === name) state.err = null;
      if (name === 'Medida') state.custom = false;
      if (name === 'Altura') {
        const o = INST.find((x) => x.key === val);
        state.inst = val; state.patas = val === 'patas';
        clickRadio('Altura', o.radio);
      } else {
        clickRadio(name, val);
      }
      decorate();
      return;
    }
    if (state.open && !e.target.closest('.armoni-dd')) { state.open = null; decorate(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && state.open) { state.open = null; decorate(); } });
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-armoni-ancho], [data-armoni-alto]')) { customVariant(); decorate(); }
  });

  // Antes de añadir al carrito: comprobar selección, variante a medida, propiedades y patas
  document.addEventListener('submit', async (e) => {
    const r = root();
    if (!r || e.target.id !== r.dataset.formId) return;
    const form = e.target;
    if (form.dataset.armoniReady === '1') { form.dataset.armoniReady = ''; return; }
    const stop = () => { e.preventDefault(); e.stopImmediatePropagation(); };

    let missing = null;
    if (!state.custom && !state.chosen.Medida) missing = 'Medida';
    else if (!state.custom && fieldset('Altura') && !state.chosen.Altura) missing = 'Altura';
    else if (fieldset('Color') && !state.chosen.Color) missing = 'Color';
    if (missing) {
      stop();
      state.err = missing; state.open = missing; decorate();
      const fs = fieldset(missing);
      if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    form.querySelectorAll('[data-armoni-prop]').forEach((n) => n.remove());
    const addProp = (k, v) => {
      const i = document.createElement('input');
      i.type = 'hidden'; i.name = `properties[${k}]`; i.value = v; i.dataset.armoniProp = '1';
      form.appendChild(i);
    };
    if (state.custom) {
      const res = customVariant();
      const alto = customValues().h;
      if (!res || !alto) {
        stop();
        const msg = state.ui.querySelector('[data-armoni-msg]');
        if (!msg.textContent) msg.textContent = 'Indica el ancho y el alto en centímetros.';
        state.ui.querySelector('[data-armoni-ancho]').focus();
        return;
      }
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = res.v.id;
      addProp('Medida a medida', `${res.w} x ${alto} cm`);
    } else if (state.inst) {
      addProp('Instalación', INST.find((x) => x.key === state.inst).label);
    }
    addProp('Regalo', '2 cojines a juego (mismo color)');
    if (state.patas && r.dataset.patasId) {
      stop();
      try {
        await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(r.dataset.patasId), quantity: 1 }] })
        });
      } catch (err) { /* si falla, seguimos con el cabecero */ }
      form.dataset.armoniReady = '1';
      form.requestSubmit();
    }
  }, true);

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', decorate) : decorate();
})();